<div class="contact-self-service-wrapper"
  [style.backgroundImage]="settings?.background ? 'url(data:image/jpeg;base64,'+ settings?.background +')' : null">
  <div class="form-container">
    <div [ngClass]="settings?.logoPosition">
      <img *ngIf="settings?.logoBase64" [src]="settings?.logoBase64" alt="Logo" class="logo">
    </div>
    <h1 class="header">{{ 'MAIN.TITLE' | translate }}</h1>
    <p class="content"
      [innerHtml]="(settings?.defaultContent.length > 0 ? settings?.defaultContent : settings?.successContent) | safehtml"></p>
    <button class="btn btn-block" (click)="tryAgain()">{{ 'BUTTON.TRY_AGAIN' | translate }}</button>
    <p class="content" [innerHtml]="settings?.footerContent | safehtml"></p>
    <app-footer customFooterClass="landing-email-screen"></app-footer>
  </div>
</div>
